import { get } from "lodash";
const MAIN_STORAGE_NAME = "web-storage";

export const getStorage = (name) => {
  try {
    const storage = localStorage.getItem(MAIN_STORAGE_NAME);
    const jsonData = JSON.parse(storage);
    return get(jsonData, name, null);
  } catch (error) {
    return null;
  }
};
